import { css } from '@linaria/core';
import { theming } from 'styles/utils';
export const infoMessage = "omponents__InfoMessage__InfoMessage_styles_ts-infoMessage-ic4j99j";

require("./InfoMessage.styles.linaria.module.css!=!../../node_modules/@linaria/webpack-loader/node_modules/@linaria/webpack5-loader/lib/outputCssLoader.js!./InfoMessage.styles.ts");